import { z } from 'zod';

import translations from '../../../../../lang';
import { validateEmail } from '../../../../../utils';

const { TRIAL_START } = translations['en-US'];
const { ERRORS } = TRIAL_START;

export const trialStartSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, ERRORS.REQUIRED)
    .refine(validateEmail, { message: ERRORS.EMAIL_FORMAT }),
});

export type TrialStartFormValues = z.infer<typeof trialStartSchema>;
